/** ****************************************************************************
* Not to be mistaken for spotlight, limelight.js is a library for highlighting
* new things in a "limelight" style view, similar to a tooltip. There's no
* initialization needed, limelight keeps all its templates in JS.
***************************************************************************** */

import $ from "jquery";

window.Limelight = {

	/**
	 * Open the limelight on a target, given some options.
	 * @arg {Object} opts - A keyed object of options.
	 * @arg {Object} opts.target - An HTML element, can be jquery or vanilla.
	 * @arg {string} opts.title - Title to be displayed alongside the limelight.
	 * @arg {string} opts.body - Body copy displayed under the title
	 * @arg {string} opts.cta - Text displayed in a CTA button.
	 * @arg {func}   opts.onClick - Function to call when CTA is clicked.
	 * @arg {func}   opts.onClose - Callback triggered when the limelight is closed for any reason.
	 * @arg {string} opts.side - "top", "bottom", "left", or "right". Side the text is on.
	 * @arg {number} opts.size - Override the calculated width and height.
	 * @arg {string} opts.color - String name of a palette color, for styling.
	 */
	open(opts) {
		if (this.isOpen) {
			this.close();
		}

		// Assign and clean up options
		this.opts = opts;
		this.opts.target = $(this.opts.target);
		this.opts.side = this.opts.side ? this.opts.side : "left";

		// Make sure our target is OK
		if (!this.opts.target || !this.opts.target.length) {
			console.error("Limelight received a bad target, not opening.");
			return false;
		}

		// Render our limelight
		$("body").append(this.render(this.opts));
		this.el = $("#limelight");
		this.container = $("#limelight_container");

		// Bind event listeners
		$(window).on("resize.limelight scroll.limelight", this.reposition.bind(this));

		// CTA by default closes it, but can be overridden
		this.el.find(".limelight-info-cta").on("click", (ev) => {
			ev.preventDefault();
			ev.stopPropagation();
			if (this.opts.onClick) {
				this.opts.onClick();
			}
			else {
				this.close();
			}
		});

		// Directly clicking on the limelight circle closes it
		this.el.on("click", (ev) => {
			ev.preventDefault();
			ev.stopPropagation();
			if (ev.target.id == this.el.attr("id")) {
				this.close();
			}
		});

		// Clicking on the target of the limelight closes it
		this.opts.target.on("click.limelight", this.close.bind(this));

		// Do initial reposition
		this.reposition();
		this.el.height();
		this.el.addClass("isShowing");
		this.isOpen = true;
		this.isOpening = true;
		setTimeout(() => {
			this.isOpening = false;
		}, 1000);
	},


	/**
	 * Repositions the limelight on its target. Automatically bound to resize
	 * and scroll, but you may need to call it if your target is moving.
	 */
	reposition() {
		const rect = this.opts.target.get(0).getBoundingClientRect();
		const size = this.opts.size ? this.opts.size :
			Math.min(Math.max(rect.width, rect.height) * 2, 400);

		this.el.css({
			width: size,
			height: size,
			marginTop: `-${size / 2}px`,
			marginLeft: `-${size / 2}px`,
			top: rect.top + rect.height / 2,
			left: rect.left + rect.width / 2,
		});
	},


	/**
	 * Close the limelight. Safe to call even if it's not open.
	 * @return {bool} Whether or not it was open when it closed.
	 */
	close() {
		// Don't close if it's not open, or is in the process of opening.
		if (!this.isOpen || this.isOpening) {
			return;
		}

		$(window).off("resize.limelight scroll.limelight");
		this.opts.target.off("click.limelight");
		this.container.remove();
		this.isOpen = false;

		if (this.opts.onClose) {
			this.opts.onClose();
		}

		return true;
	},


	/**
	 * Returns
	 */
	render(opts) {
		const classes = ["limelight-info"];
		let title,
			body,
			cta;

		if (opts.title) {
			title = `<div class="limelight-info-title">${opts.title}</div>`;
		}

		if (opts.body) {
			body = `<div class="limelight-info-body">${opts.body}</div>`;
		}

		if (opts.cta) {
			cta = `
				<button class="limelight-info-cta flatbutton green">
					${opts.cta}
				</button>
			`;
		}

		if (opts.side) {
			classes.push(`limelight-info--${opts.side}`);
		}

		if (opts.color) {
			classes.push("limelight-info--colored");
			classes.push(`limelight-info--${opts.color}`);
		}

		return `
			<div id="limelight_container">
				<div id="limelight" class="limelight">
					<div class="${classes.join(" ")}">
						${title}
						${body}
						${cta}
					</div>
				</div>
			</div>
		`;
	},
};



// WEBPACK FOOTER //
// ./src/legacy/limelight.js